export enum VisibilityType {
  HIDDEN = 'HIDDEN',
  READONLY = 'READONLY',
}
